export const AccordionItemButtonStyle =
  'flex w-full justify-between rounded-lg bg-background px-4 py-2 text-left text-sm font-medium text-foreground/80 hover:bg-foreground/5 focus:outline-hidden focus-visible:ring-3 focus-visible:ring-gray-500 focus-visible:ring-opacity-75';
export const AccordionItemPanelStyle = 'text-sm';
